import {useParams} from 'react-router-dom'
import moment from 'moment'
import useFetchReportById from '../../../hooks/useFetchReportById'

const ReportsDetailsViewOverview = () => {
  const {id} = useParams()
  const {report, error, loading} = useFetchReportById(id as string)
  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Report Details</h3>
          </div>

          {/* <Link
            to='#'
            to={`${id}/edit-ad`}
            className='btn btn-primary align-self-center'
          >
            Edit Ad
          </Link> */}
        </div>

        {/* Full Name */}
        <div className='card-body p-9'>
          {/* <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Image</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{data?.name ? data.name : '100x100'}</span>
            </div>
          </div> */}

          {/* Ad Name */}
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Name</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>
                {report?.user ? report.user.first_name : 'Loading'}
              </span>
            </div>
          </div>

          {/* Contact */}
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>
              Email
              <i
                className='fas fa-exclamation-circle ms-1 fs-7'
                data-bs-toggle='tooltip'
                title='Email must be active'
              ></i>
            </label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>
                {report?.user ? report?.user?.email : 'Loading'}
              </span>

              {/* <span className='badge badge-success'>Verified</span> */}
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Description</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>
                {report?.description
                  ? report?.description
                  : report?.description == ''
                  ? 'NOT PROVIDED'
                  : ''}
              </span>
            </div>
          </div>

          {/* Gender */}
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>status</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>{report?.status ? report.status : 'Loading'}</span>
            </div>
          </div>

          {/* Start Time */}
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Issued at</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>
                {report?.createdAt ? moment(new Date(report?.createdAt)).format('LL') : 'Loading'}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className='row gy-10 gx-xl-10'>
        <div className='col-xl-6'>
          {/* <ChartsWidget1 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>

        <div className='col-xl-6'>
          {/* <TablesWidget1 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>
      </div>

      <div className='row gy-10 gx-xl-10'>
        <div className='col-xl-6'>
          {/* <ListsWidget5 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>

        <div className='col-xl-6'>
          {/* <TablesWidget5 className='card-xxl-stretch mb-5 mb-xl-10' /> */}
        </div>
      </div>
    </>
  )
}

export default ReportsDetailsViewOverview
